import { useEffect } from 'react';
import { useAppSelector } from './redux';
import { SubscriptionTypes } from '../models/subscription/enums';

interface Foldspace {
    (command: 'when', event: 'ready', callback: () => void): void;
    identify: (context: object, callback: () => void) => void;
    getVariant: (name: string, fallback: boolean) => boolean;
    agent: (name: string) => void;
}

const getFoldspacePlan = (planName: SubscriptionTypes | undefined): string => {
    switch (planName) {
        case SubscriptionTypes.INDIVIDUAL:
        case SubscriptionTypes.OFFICE:
            return 'paid';
        case SubscriptionTypes.FREE_TRIAL_INDIVIDUAL:
        case SubscriptionTypes.FREE_TRIAL_OFFICE:
            return 'evaluation';
        default:
            return 'free';
    }
};

// Identifies the signed-in user to the Foldspace agent loaded in public/index.html.
export const useFoldspaceIdentify = (): void => {
    const user = useAppSelector((state) => state.authReducer.user);

    useEffect(() => {
        const foldspace = (window as unknown as { foldspace?: Foldspace }).foldspace;
        if (!user || !foldspace) {
            return;
        }
        const context = {
            user: {
                id: String(user.id),
                email: user.email,
                name: `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
                role: user.accountRole || user.appRole,
                plan: getFoldspacePlan(user.subscriptionPlanName),
            },
        };
        foldspace('when', 'ready', () => {
            foldspace.identify(context, () => {
                if (foldspace.getVariant('enable_agent_in_app', false)) {
                    foldspace.agent('transparencycatalog-agent');
                }
            });
        });
    }, [user?.id, user?.email, user?.accountRole, user?.subscriptionPlanName]);
};
